import translator from '@Components/Utilities/Translator';
import { WidgetButton } from '@Components/MuiWrappers/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const WidgetPaper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    height: '70px',
    marginBottom: '15px',
    '&:hover': {
        boxShadow: '2px 5px 3px 0px rgb(0 0 0 / 20%), 2px 4px 4px 2px rgb(0 0 0 / 14%), 2px 3px 7px 2px rgb(0 0 0 / 12%)'
    }
}));

const Widget = (props) => {

    return (props.showWidget &&
        (props.registrationPage ?
        <a rel='nofollow' className={props.className} target='_blank' href={props.url} aria-label={props.label + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
            <WidgetPaper elevation={2}>
                    {props.imageSource && !props.IsRedesign &&
                        <div className='widget__image-container'>
                            <img className='widget__image' src={props.imageSource} alt="" />
                        </div>}
                <div className='widget__text'>
                    <Typography>
                        <span>{props.label}</span>
                    </Typography>
                    </div>
                </WidgetPaper>
            </a> :
            <div className={props.className}>
            <WidgetButton rel='nofollow' aria-label={props.label + " (" + translator.translate('sandhills.opensinanewtab') + ")"} variant='contained' size='small' href={props.url} target='_blank' className='listing-widget__link' onClick={props.saveAction} style={{ padding: props.IsRedesign ? '5px 5px' : '', maxHeight: props.IsRedesign ? '45px' : '', minHeight: props.IsRedesign ? '31px' :'' }} > 
                {props.imageSource && !props.IsRedesign &&
                        <img src={props.imageSource} style={{ marginRight: '5px' }} className='listing-widget__image' alt="" />}
                    <span className='listing-widget__text'>{props.label}</span>
                </WidgetButton>
            </div>
        )
    );
};

export default Widget;